import { ToolbarAction, ToolbarButtonData, ToolbarSliderOptions, ToolbarTimelineOptions } from '../types';

export interface SeButtonsToolbarState {
    buttons: Partial<Record<ToolbarAction, ToolbarButtonData>>;
    leftSlider: ToolbarSliderOptions;
    rightSlider: ToolbarSliderOptions;
    timeline?: ToolbarTimelineOptions;
}

export const SLIDER_OPTIONS: Record<string, ToolbarSliderOptions> = {
    LEFT_SLIDER_OPEN: {
        checked: true,
        enabled: true,
        visible: true,
        overlap: false,
    },
    LEFT_SLIDER_CLOSED: {
        checked: false,
        enabled: true,
        visible: true,
        overlap: false
    },
    LEFT_SLIDER_DISABLED: {
        checked: false,
        enabled: false,
        visible: false,
        overlap: false
    },
    RIGHT_SLIDER_OPEN: {
        checked: true,
        enabled: true,
        visible: true,
        overlap: false
    },
    RIGHT_SLIDER_CLOSED: {
        checked: false,
        enabled: true,
        visible: true,
        overlap: false
    },
    RIGHT_SLIDER_OVERLAP_CLOSED: {
        checked: false,
        enabled: true,
        visible: true,
        overlap: true
    },
    RIGHT_SLIDER_DISABLED: {
        checked: false,
        enabled: false,
        visible: false,
        overlap: false
    },
};

export const TIMELINE_OPTIONS: Record<string, ToolbarTimelineOptions> = {
    TIMELINE_OPEN: {
        active: true,
        open: true
    },
    TIMELINE_CLOSED: {
        active: true,
        open: false
    },
    // timeline_disabled è lo stato di default iniziale per evitare che sia visualizzato in toolbar il pulsante (evita flickers)
    TIMELINE_DISABLED: {
        active: false,
        open: false
    },
    // no_timeline indica che la timeline non sarà visibile ANCHE SE, in pagina è presente la storia clinica
    NO_TIMELINE: {
        active: false,
        open: false,
        noShow: true
    }
}

export const seButtonsToolbarInitialState: SeButtonsToolbarState = {
    buttons: {},
    leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
    rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_OPEN,
    timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED
};
